module.exports = __webpack_public_path__ + "img/img10.51e5a039.svg";